import React from "react";
import "./component.css";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import {
  TextField,
  Checkbox,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  Typography,
} from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";
import uploadImage from "../../../assests/uploadImage.svg";
import CancelIcon from "@mui/icons-material/Cancel";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";

const ComboCreateComponent = (props) => {
  const navigate = useNavigate();
  const handleClick = () => navigate(-1);

  const setPrice = (newPrice, itemId) => {
    const updatedItems = props?.selectedMvItems.map((item) =>
      item.id === itemId ? { ...item, price: newPrice } : item
    );
    props.setSelectedMvItems(updatedItems);
  };

  return (
    <div className="combo-create-container">
      <Sidebar />

      <div className="combo-create-content">
        <div className="combo-create-header">
          <button onClick={handleClick} className="back-button">
            <img src={leftArrow} alt="Back" />
          </button>
          <h1>Create Combo</h1>
        </div>

        <div className="combo-form-container">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <div className="combo-form">
              {/* Form Fields */}
              <div className="form-field">
                <TextField
                  label="Name"
                  autoComplete="off"
                  fullWidth
                  variant="standard"
                  value={props.name}
                  onChange={(e) => props.setName(e.target.value)}
                  className="styled-textfield"
                />
                {props.errors?.name && (
                  <span className="error-text">{props.errors.name}</span>
                )}
              </div>

              <div className="form-field">
                <TextField
                  label="Description"
                  variant="standard"
                  fullWidth
                  value={props.description}
                  onChange={(e) => props.setDescription(e.target.value)}
                  className="styled-textfield"
                />
                {props.errors?.description && (
                  <span className="error-text">{props.errors.description}</span>
                )}
              </div>

              <div className="price-fields">
                <div className="form-field">
                  <TextField
                    label="MRP"
                    variant="standard"
                    fullWidth
                    type="number"
                    inputProps={{ maxLength: 6 }}
                    value={props.retail_price}
                    onChange={(e) => props.setretail_price(e.target.value)}
                    className="styled-textfield"
                  />
                  {props.errors?.retail_price && (
                    <span className="error-text">{props.errors.retail_price}</span>
                  )}
                </div>

                <div className="form-field">
                  <TextField
                    label="Selling price"
                    variant="standard"
                    fullWidth
                    type="number"
                    inputProps={{ maxLength: 6 }}
                    value={props.offer_price}
                    onChange={(e) => props.setoffer_price(e.target.value)}
                    className="styled-textfield"
                  />
                  {props.errors?.offer_price && (
                    <span className="error-text">{props.errors.offer_price}</span>
                  )}
                </div>
              </div>

              <div className="date-range">
                <div className="form-field">
                  <DateTimePicker
                    label="Starting Date"
                    value={props.startDate}
                    onChange={(date) => props.setStartDate(date)}
                    minDate={new Date()}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        className="styled-textfield"
                      />
                    )}
                  />
                  {props.errors?.startDate && (
                    <span className="error-text">{props.errors.startDate}</span>
                  )}
                </div>

                <div className="form-field">
                  <DateTimePicker
                    label="Expire Date"
                    value={props.endDate}
                    onChange={(date) => props.setEndDate(date)}
                    minDate={props.startDate || new Date()}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        className="styled-textfield"
                      />
                    )}
                  />
                </div>
              </div>
              {props.errors?.date && (
                <span className="error-text">{props.errors.date}</span>
              )}

              <div className="image-upload">
                <p>Image</p>
                {!props.selectedFile ? (
                  <Button
                    variant="outlined"
                    component="label"
                    fullWidth
                    className="upload-button"
                  >
                    <div className="upload-content">
                      <img src={uploadImage} alt="Upload icon" />
                      <p>Choose file or drag here</p>
                    </div>
                    <input
                      type="file"
                      hidden
                      onChange={props.handleFileChange}
                    />
                  </Button>
                ) : (
                  <div className="image-preview">
                    <img
                      src={props.imagePreview}
                      alt="Selected file preview"
                    />
                    <IconButton
                      onClick={props.handleRemoveFile}
                      className="remove-image-button"
                    >
                      <CancelIcon fontSize="small" />
                    </IconButton>
                  </div>
                )}
                <Button
                  onClick={props.handleImageUpload}
                  variant="outlined"
                  color="success"
                  className="upload-confirm-button"
                >
                  Upload Image
                </Button>
                {props.errors?.file && (
                  <span className="error-text">{props.errors.file}</span>
                )}
              </div>

              <div className="apply-on">
                <p>Apply on</p>
                <div className="checkbox-group">
                  <div className="checkbox-item">
                    <Checkbox
                      checked={props.applyOnKiosk}
                      onChange={(e) => props.setApplyOnKiosk(e.target.checked)}
                      className="styled-checkbox"
                    />
                    <span>Kiosk</span>
                  </div>
                  <div className="checkbox-item">
                    <Checkbox
                      checked={props.applyOnConsumerApp}
                      onChange={(e) =>
                        props.setApplyOnConsumerApp(e.target.checked)
                      }
                      className="styled-checkbox"
                    />
                    <span>Consumer App</span>
                  </div>
                </div>
                {props.errors?.selection && (
                  <span className="error-text">{props.errors.selection}</span>
                )}
              </div>

              <div className="mv-items-section">
                <div className="mv-id-input">
                  <TextField
                    label="Click to add MV ID"
                    fullWidth
                    disabled
                    value={props.mvId}
                    onChange={(e) => props.setMvId(e.target.value)}
                    className="styled-textfield"
                  />
                  <Button
                    onClick={props.handleOpenModal}
                    className="add-mv-button"

                  >
                    Add
                  </Button>
                </div>
                {props.errors?.mvConfig && (
                  <span className="error-text">{props.errors.mvConfig}</span>
                )}

                <div className="selected-mv-items">
                  {props.selectedMvItems.map((item, index) => (
                    <div key={index} className="mv-item-card">
                      <span className="mv-item-id">ID: {item.id}</span>
                      <TextField
                        label="Selling Price"
                        variant="standard"
                        fullWidth
                        type="number"
                        maxLength="6"
                        value={item.price || ""}
                        onChange={(e) => setPrice(e.target.value, item.id)}
                        className="price-input"
                      />
                      <div className="quantity-control">
                        <IconButton
                          onClick={() => props.decrementQuantity(item.id)}
                          className="quantity-button"
                        >
                          <RemoveIcon />
                        </IconButton>
                        <span className="quantity-value">{item.quantity}</span>
                        <IconButton
                          onClick={() => props.incrementQuantity(item.id)}
                          className="quantity-button"
                        >
                          <AddIcon />
                        </IconButton>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <Dialog
                open={props.modalOpen}
                onClose={props.handleCloseModal}
                className="mv-selection-dialog"
                fullWidth
                maxWidth="md"
                PaperProps={{
                  style: {
                    height: '80vh',
                    display: 'flex',
                    flexDirection: 'column'
                  }
                }}
              >
                <DialogTitle className="dialog-title">
                  Select an MV ID
                  <IconButton
                    onClick={props.handleCloseModal}
                    style={{ position: 'absolute', right: 8, top: 8 }}
                  >
                    <CancelIcon />
                  </IconButton>
                </DialogTitle>

                <DialogContent style={{ padding: '16px', flex: 1, overflow: 'hidden' }}>
                  <TextField
                    label="Search MV ID"
                    fullWidth
                    type="number"
                    autoComplete="off"
                    value={props.searchQuery}
                    onChange={props.handleSearchQueryChange}
                    variant="outlined"
                    className="search-mv-input"
                    style={{ marginBottom: '16px' }}
                  />

                  <div style={{
                    overflow: 'auto',
                    height: 'calc(100% - 56px)',
                    position: 'relative'
                  }}>
                    <Table stickyHeader className="mv-table">
                      <TableHead>
                        <TableRow>
                          <TableCell style={{
                            minWidth: '80px',
                            fontWeight: 'bold',
                            backgroundColor: '#f5f5f5'
                          }}>Select</TableCell>
                          <TableCell style={{
                            minWidth: '100px',
                            fontWeight: 'bold',
                            backgroundColor: '#f5f5f5'
                          }}>ID</TableCell>
                          <TableCell style={{
                            minWidth: '200px',
                            fontWeight: 'bold',
                            backgroundColor: '#f5f5f5'
                          }}>Product Name</TableCell>
                          <TableCell style={{
                            minWidth: '100px',
                            fontWeight: 'bold',
                            backgroundColor: '#f5f5f5'
                          }}>Price</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {props.filteredMvList?.length > 0 ? (
                          props.filteredMvList.map((item, index) => (
                            <TableRow
                              key={index}
                              hover
                              onClick={() => props.handleSelectMvId(item)}
                              style={{ cursor: 'pointer' }}
                            >
                              <TableCell>
                                <Radio
                                  checked={props.selectedMvItem?.id === item.id}
                                  onChange={() => props.handleSelectMvId(item)}
                                  value={item.id}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </TableCell>
                              <TableCell >{item.id}</TableCell>
                              <TableCell>{item.variant_name}</TableCell>
                              <TableCell >{item.offer_price}</TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={4} style={{ textAlign: 'center', padding: '20px' }}>
                              {props.isLoading ? 'Loading...' : 'No results found'}
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </div>
                </DialogContent>


              </Dialog>
            </div>
          </LocalizationProvider>
        </div>

        <div className="submit-button-container">
          <Button
            className="submit-button"
            onClick={props.submitApiButton}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};
export default ComboCreateComponent;